export enum Icons {
  ALARM_BELL = 'alarm-bell',
  ARROW_LEFT = 'arrow-left',
  ARROW_RIGHT = 'arrow-right',
  ARROW_RIGHT_CORNER = 'arrow-right-corner',
  CLM = 'clm',
  COLLECTIONS = 'collections',
  DASHBOARD = 'dashboard',
  DD = 'destiny-discover',
  DESTINY = 'back-office',
  DESTINY_EXPRESS = 'destiny-express',
  DISCOVER_MANAGER = 'discover-manager',
  FOLLETT_LEARNING = 'follett-learning',
  FOLLETT_COMMUNITY = 'follett-community',
  FUNDRAISING = 'fundraising',
  HELP_DESK = 'help-desk',
  MASTERLIBRARY_CAPITAL = 'ml-capital',
  MASTERLIBRARY_BINDERS = 'ml-binders',
  MASTERLIBRARY_DRAWINGS = 'ml-drawings',
  MASTERLIBRARY_PROJECTS = 'ml-projects',
  MASTERLIBRARY_SCHEDULES = 'ml-schedules',
  MASTERLIBRARY_WORKORDERS = 'ml-workorders',
  INFO = 'information-outline',
  LAYOUT_DASHBOARD = 'layout-dashboard',
  TITLEWAVE = 'titlewave',
  WAFFLE = 'waffle',
  LOGIN = 'login',
  LOGOUT = 'logout',
  EXPAND_MORE = 'expand-more',
  FOLLETT_LOGO = 'follett-logo',
  CLOSE = 'close',
  SCHOOL = 'school',
  SEARCH = 'search',
  CLEAR = 'clear',
  CHECKMARK = 'checkmark',
  USER_PROFILE = 'user-profile',
  PALETTE = 'palette',
  SECRET = 'secret',
  SEND = 'send',
  HAMBURGER_MENU = 'hamburger-menu',
  CONTENT_COPY = 'content-copy',
  APP_WINDOW_TWO = 'app-window-two',
  NEW_FOLLETT_LOGO = 'new-follett-logo',
  NEW_FOLLETT_LOGO_SMALL = 'new-follett-logo-small',
  NEW_FOLLETT_LOGO_WHITE = 'new-follett-logo-white',
  NEW_FOLLETT_LOGO_WHITE_SMALL = 'new-follett-logo-white-small',
  SIDEBAR_ICONS = 'sidebar-icons'
}

export default Icons;
